import { render, staticRenderFns } from "./InvestmentHeaderWithLogo.vue?vue&type=template&id=0f7f1452&scoped=true"
import script from "./InvestmentHeaderWithLogo.vue?vue&type=script&lang=ts"
export * from "./InvestmentHeaderWithLogo.vue?vue&type=script&lang=ts"
import style0 from "./InvestmentHeaderWithLogo.vue?vue&type=style&index=0&id=0f7f1452&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7f1452",
  null
  
)

export default component.exports